module.exports = __webpack_public_path__ + "media/step_2_en.ae22f2f0.mp3";